import { ButtonGhost, TooltipContainer } from '@kc-console/common-ui';

import { INITIAL_TOOLTIP_BUTTON_TIMEOUT } from './types';

import type { ButtonGhostProps } from '@kc-console/common-ui';
import type { TooltipButtonProps } from './types';

const TooltipButtonGhost = (props: TooltipButtonProps<ButtonGhostProps>) => {
  const {
    message = '',
    children,
    placement = 'top',
    click = false,
    timeout = INITIAL_TOOLTIP_BUTTON_TIMEOUT,
    tooltipProps: tooltipPropsProp,
    disabled,
    fullWidth,
    ref,
    ...others
  } = props;

  return (
    <TooltipContainer
      message={message}
      placement={placement}
      click={click}
      timeout={timeout}
      tooltipProps={tooltipPropsProp}
      disabled={disabled}
      display={fullWidth ? 'block' : 'inline-block'}
      width={fullWidth ? '100%' : 'fit-content'}
    >
      <ButtonGhost ref={ref} {...others}>
        {children}
      </ButtonGhost>
    </TooltipContainer>
  );
};

export default TooltipButtonGhost;
